import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {LeadRealtimeChange} from "@project/sdk/realtime";

import {leadKeys} from "../lead-keys";

type LeadRealtimeChangeEvent = output<typeof LeadRealtimeChange>;

export const leadsRealtimeHandler: ResourceChangeRealtimeHandler<LeadRealtimeChangeEvent> = {
  resource: "sales.leads",
  queryKey: leadKeys.all,
  eventSchema: LeadRealtimeChange,
  async handleEvent(event, queryClient) {
    if (event.change === "CREATED") {
      await queryClient.invalidateQueries({queryKey: leadKeys.lists()});

      return;
    }

    await queryClient.invalidateQueries({queryKey: leadKeys.all});
  },
};
